export default "__VITE_ASSET__jydcYbfI__"